import React from 'react'
import { Routes, Route, Navigate } from 'react-router-dom'
import RoleRoute from '@BUP/routes/RoleRoute'
import UserSendBraveupModePage from '@BUP/pages/ModeBup/UserSendBraveupModePage'
import ChatBoxPage from '@BUP/pages/ModeBup/chatBoxPage'
import BupArchivedPage from '@BUP/pages/ModeBup/archived'
import { ModeBupContextProvider } from '@BUP/contexts/ModeBupContext'
import { RolesContextProvider } from '@BUP/contexts/RolesContext'
import UserInboxPage from '@BUP/pages/ModeBup/userInboxPage'

const ModeBupNavigation = () => {
  return (
    <ModeBupContextProvider>
      <RolesContextProvider>
        <Routes>
          <Route
            path='inbox'
            element={
              <RoleRoute name='UserInboxPage'>
                <UserInboxPage />
              </RoleRoute>
            }
          />
          <Route
            path='send'
            element={
              <RoleRoute name='UserSendBraveupModePage'>
                <UserSendBraveupModePage />
              </RoleRoute>
            }
          />
          <Route
            path='direct'
            element={
              <RoleRoute name='ChatBoxPage'>
                <ChatBoxPage />
              </RoleRoute>
            }
          />
          <Route
            path='archived'
            element={
              <RoleRoute name='BupArchivedPage'>
                <BupArchivedPage />
              </RoleRoute>
            }
          />
          <Route
            path='*'
            element={<Navigate to='send' />}
          />
        </Routes>
      </RolesContextProvider>
    </ModeBupContextProvider>
  )
}

export default ModeBupNavigation
